import { Stack } from "../../mui";
import { EmailComposerBody } from "./EmailComposerBody";
import { EmailComposerRecipients } from "./EmailComposerRecipients";
import { EmailComposerSubject } from "./EmailComposerSubject";

export const EmailComposer = (props: {
  showRecipients?: boolean;
  recipients?: string[];
  setRecipients?: (value: string[]) => void;
  readOnlyRecipients?: boolean;
  showSubject?: boolean;
  subject?: string | undefined;
  setSubject?: (value: string | undefined) => void;
  showBody?: boolean;
  bodyHtml?: string | undefined;
  setBodyHtml?: (value: string | undefined) => void;
  bodyHeight?: string;
}) => {
  return (
    <Stack direction="column" spacing="sm">
      {props.showRecipients && (
        <EmailComposerRecipients
          value={props.recipients!}
          onChange={props.setRecipients!}
          readOnly={props.readOnlyRecipients}
        />
      )}

      {props.showSubject && <EmailComposerSubject value={props.subject} onChange={props.setSubject!} />}

      {props.showBody && (
        <EmailComposerBody value={props.bodyHtml} onChange={props.setBodyHtml!} bodyHeight={props.bodyHeight} />
      )}
    </Stack>
  );
};
